import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { changeJurisdiction, fetchOpinionTerms } from '../../actions';

class Jurisdictions extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			showJurisdictions: true
		};
		this.toggleShowJurisdictions = this.toggleShowJurisdictions.bind( this );
	}

	componentWillMount() {
		if ( !this.props.jurisdictions.length ) {
			this.props.fetchOpinionTerms( 'opinion_jurisdiction' );
		}
	}

	renderJurisdictions( jurisdictions ) {
		return jurisdictions.map( jurisdiction => {
			return (<option key={ jurisdiction.id } value={ jurisdiction.id }
			                dangerouslySetInnerHTML={ { __html: jurisdiction.name } }/>
			);
		} );
	}

	handleChange( event ) {
		this.props.changeJurisdiction( event.target.value );
	}

	toggleShowJurisdictions() {
		this.setState( { showJurisdictions: !this.state.showJurisdictions } );
	}

	render() {
		return (<div>
				<div className="sidebar-heading-container">
					<h2 className="sidebar-heading">Jurisdiction</h2>
					<i className={ `fa-solid fa-chevron-${ this.state.showJurisdictions
					                                       ? 'up'
					                                       : 'down' } filter-toggle-icon` }
					   onClick={ this.toggleShowJurisdictions }></i>
				</div>
				{ this.state.showJurisdictions && (<Fragment>
						<p className="sidebar-description">
							Please select the jurisdiction you want to explore.
						</p>
						<select id="jurisdiction-filter"
						        className="form-control"
						        onChange={ this.handleChange.bind( this ) }>
							<option value="">All Jurisdictions</option>

							{ this.renderJurisdictions( this.props.jurisdictions ) }
						</select>
					</Fragment>
				) }
			</div>
		);
	}
}

function mapStateToProps( { jurisdictions, selectedJurisdiction } ) {
	return { jurisdictions, selectedJurisdiction };
}

export default connect( mapStateToProps, {
	fetchOpinionTerms, changeJurisdiction
} )( Jurisdictions );